import jxWindowCache from '../../../JxControls/JxWindowManager/JxWindowCache';
import windowPositionPublisher from '../../../JxControls/JxWindowManager/windowPositionPublisher';

/**
 * Copies all cached window geo's to another geo scope (BE WindowPosition per tabId),
 * so a "Save As" workspace opens with the exact layout it was created from.
 */
export default class WorkspaceGeoCopier {
    /**
     * @param {string} scopeId - target tabId, see AppContext.getGeoScopeIdFor()
     * @returns {Promise<void>}
     */
    static async copyToScope(scopeId) {
        const posts = jxWindowCache.getAll().map((g) => windowPositionPublisher.publish(WorkspaceGeoCopier._toDto(g, scopeId)));
        await Promise.all(posts);
    }

    static _toDto(g, scopeId) {
        return {
            rk: g.rk,
            posX: g.posX,
            posY: g.posY,
            width: g.width,
            height: g.height,
            isPinned: g.isPinned,
            displayState: g.displayState,
            restoreGeo: g.restoreGeo,
            targetAnchor: g.targetAnchor,
            tabId: scopeId,
            ems: Date.now(),
        };
    }
}
